<template>
    <div>
        Через 10 секунд появился рассылка, ожидайте...
    </div>
    <!-- <div class="sp-form-outer sp-popup-outer" style="background: rgba(0, 0, 0, 0.5);">
        <div id="sp-form-216779" sp-id="216779" sp-hash="6ab7d1d8e8dd4d0d03be5de7fadd14999ce9505a8d65e20c5bf65e19b1ad2bfa" sp-lang="ru" class="sp-form sp-form-regular  sp-form-popup sp-form-horizontal" sp-show-options="%7B%22satellite%22%3Afalse%2C%22maDomain%22%3A%22login.sendpulse.com%22%2C%22formsDomain%22%3A%22forms.sendpulse.com%22%2C%22condition%22%3A%22onEnter%22%2C%22scrollTo%22%3A25%2C%22delay%22%3A10%2C%22repeat%22%3A3%2C%22background%22%3A%22rgba(0%2C%200%2C%200%2C%200.5)%22%2C%22position%22%3A%22bottom-right%22%2C%22animation%22%3A%22%22%2C%22hideOnMobile%22%3Afalse%2C%22submitRedirectUrl%22%3A%22https%3A%2F%2Fzmi59.ru%22%2C%22urlFilter%22%3Afalse%2C%22urlFilterConditions%22%3A%5B%7B%22force%22%3A%22hide%22%2C%22clause%22%3A%22contains%22%2C%22token%22%3A%22%22%7D%5D%2C%22analytics%22%3A%7B%22ga%22%3A%7B%22eventLabel%22%3A%22%D0%A4%D0%BE%D1%80%D0%BC%D0%B0_%D0%BF%D0%BE%D0%B4%D0%BF%D0%B8%D1%81%D0%BA%D0%B8_%D0%9E%D0%A1%D0%9D%D0%9E%D0%92%D0%90_%D0%B8%D1%8E%D0%BD%D1%8C_2021%22%2C%22send%22%3Afalse%7D%2C%22ym%22%3A%7B%22counterId%22%3Anull%2C%22eventLabel%22%3Anull%2C%22targetId%22%3Anull%2C%22send%22%3Afalse%7D%7D%2C%22utmEnable%22%3Afalse%7D">

            <div class="sp-form-fields-wrapper">
                <button class="sp-btn-close ">&nbsp;</button>
                <div class="sp-message">
                    <div>
                    </div>
                </div>
                <form novalidate="" class="sp-element-container ">
                    <div class="sp-field sp-field-full-width" sp-id="sp-e62b9b1e-474a-4d2f-94ac-ca539b2ef6b4">
                        <div style="font-family: inherit; line-height: 1.2;">
                            <p>Раз в неделю мы отправляем дайджест с самыми свежими новостями.</p>
                        </div>
                    </div>
                    <div class="sp-field " sp-id="sp-a977544e-92d2-4459-b6ce-a343b343edac">
                        <div class="sp-checkbox-option">
                            <label>
                                <input type="checkbox" sp-type="gdprConfirm" name="sform[Z2RwckNvbmZpcm0=]" value="yes" sp-tips="%7B%22required%22%3A%22%D0%9E%D0%B1%D1%8F%D0%B7%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5%20%D0%BF%D0%BE%D0%BB%D0%B5%22%7D" class=" " required="required">
                                <span>Да, пожалуйста уведомляйте меня о новостях, событиях и предложениях</span>&nbsp;
                                <span ><strong>*</strong></span>
                            </label>
                        </div>
                    </div>
                    <div class="sp-field " sp-id="sp-c0e3aabd-1b39-43e3-890a-ceca9fa4dfc8">
                        <div class="sp-checkbox-option">
                            <label>
                                <input type="checkbox" sp-type="gdprTerms" name="sform[Z2RwclRlcm1z]" value="yes" sp-tips="%7B%22required%22%3A%22%D0%9E%D0%B1%D1%8F%D0%B7%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5%20%D0%BF%D0%BE%D0%BB%D0%B5%22%7D" class=" " required="required">
                                <span>Подписываясь на рассылку, вы соглашаетесь с 
                                    <a href="" target="_blank">Правилами пользования и Политикой конфиденциальности</a> и даете согласие на использование файлов cookie и передачу своих персональных данных в 
                                </span>&nbsp;
                                <span><strong>*</strong></span>
                            </label>
                        </div>
                    </div>
                    <div class="sp-field " sp-id="sp-5436c859-8028-4a78-85d9-9da1290e29f2">
                        <label class="sp-control-label">
                            <span >Email</span><strong >*</strong>
                        </label>
                        <input type="email" sp-type="email" name="sform[email]" class="sp-form-control " placeholder="username@gmail.com" sp-tips="%7B%22required%22%3A%22%D0%9E%D0%B1%D1%8F%D0%B7%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5%20%D0%BF%D0%BE%D0%BB%D0%B5%22%2C%22wrong%22%3A%22%D0%9D%D0%B5%D0%B2%D0%B5%D1%80%D0%BD%D1%8B%D0%B9%20email-%D0%B0%D0%B4%D1%80%D0%B5%D1%81%22%7D" autocomplete="on" required="required">
                    </div>
                    <div class="sp-field sp-button-container sp-lg" sp-id="sp-de70721f-7e2c-4901-a48e-bc6dd477f841">
                        <button id="sp-de70721f-7e2c-4901-a48e-bc6dd477f841" class="sp-button">Подписаться</button>
                    </div>
                </form>
                <div class="sp-link-wrapper sp-brandname__left">
                    <a class="sp-link " target="_blank" 
                    href="https://sendpulse.com/ru/forms-powered-by-sendpulse?sn=0J7QntCeINCX0LDQstC%2B0LQg0LzQtdGC0LDQu9C70LjRh9C10YHQutC40YUg0LjQt9C00LXQu9C40Lk%3D">
                        <span class="sp-link-img">&nbsp;</span>
                        <span translate="FORM.PROVIDED_BY">Предоставлено SendPulse</span>
                    </a>
                </div>
            </div>
        </div>
    </div> -->
</template>

<script>
  export default {
    mounted() {
      let my_script = document.createElement('script')
      my_script.setAttribute('src', "https://web.webformscr.com/apps/fc3/build/loader.js")
      my_script.async = true
      my_script.setAttribute('sp-form-id', '6ab7d1d8e8dd4d0d03be5de7fadd14999ce9505a8d65e20c5bf65e19b1ad2bfa')
      document.head.appendChild(my_script)
    },
  }
</script>

